import React from 'react';
import Rowfooter from './row-info-footer';
import pic34 from '../../assets/pic34.png'
import pic35 from '../../assets/pic35.png'
import pic36 from '../../assets/pic36.png'
import './list2-footer.css'
import { useTranslation } from 'react-i18next';



const List2footer = (props) => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';


    return ( 
        <nav className='list2-footerr' dir={direction}>
            <h2 className='header-listtwo-footer'>{props.title}</h2>
            <nav className='list-footerrr'>
               <Rowfooter  title={t('12 Nile Street, Cairo, Egypt')} img={pic34}/>
                <Rowfooter  title= {t('+1 (555) 123-4567')}img={pic35}/>
                 <Rowfooter  title='MusicTicket@email.com' img={pic36}/>
            </nav>
        </nav>
     );
}
 
export default List2footer;